export const roleContextQueryKeys = {
  all: ['role-context'] as const,
  available: () => [...roleContextQueryKeys.all, 'available'] as const,
  current: () => [...roleContextQueryKeys.all, 'current'] as const,
};
